module.exports = __webpack_public_path__ + "img/logo.bf6f400c.png";